<template>
  <template v-if="$hasPermission('a3m_core.DestinationManagerGeoBot')">
    <slot name="activator" :open="openDrawer">
      <v-btn
        class="geobot-fab"
        color="primary"
        icon
        size="large"
        title="GeoBot"
        @click="openDrawer"
      >
        <v-icon>chat</v-icon>
      </v-btn>
    </slot>
    <Teleport to="body">
      <v-navigation-drawer
        :model-value="open"
        class="geobot-drawer"
        location="end"
        temporary
        width="420"
        @update:model-value="open = $event"
      >
        <v-toolbar density="compact" title="GeoBot" class="geobot-toolbar">
          <v-spacer />
          <v-btn icon variant="text" @click="open = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="geobot-content">
          <div v-if="loading" class="d-flex align-center justify-center fill-height">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <div v-else-if="error" class="d-flex align-center justify-center fill-height flex-column pa-4">
            <p class="text-body-2 text-medium-emphasis">{{ error }}</p>
            <v-btn color="primary" variant="tonal" @click="loadUrl">Retry</v-btn>
          </div>
          <iframe
            v-else-if="iframeUrl"
            :src="iframeUrl"
            class="geobot-iframe"
            title="GeoBot"
          />
        </div>
      </v-navigation-drawer>
    </Teleport>
  </template>
</template>

<script>
import axios from '@/axiosClient'
import { backendAuthUrl } from '@/settings'
import { mapState } from 'vuex'

export default {
  name: 'GeoBotFab',
  data() {
    return {
      open: false,
      iframeUrl: null,
      loading: false,
      error: null,
    }
  },
  computed: {
    ...mapState({
      language: state => state.uiStore.language,
    }),
  },
  watch: {
    open(isOpen) {
      if (isOpen) {
        if (!this.iframeUrl && !this.loading && !this.error) this.loadUrl()
      } else {
        this.iframeUrl = null
        this.error = null
      }
    },
  },
  methods: {
    openDrawer() {
      this.open = true
    },
    geobotIframeSrc(apiUrl) {
      if (!apiUrl) return null
      try {
        const u = new URL(apiUrl)
        const code = String(this.language || 'de')
          .trim()
          .toLowerCase()
          .split(/[-_]/)[0]
        if (code && code !== 'de') {
          u.searchParams.set('lang', 'en')
        }
        return u.toString()
      } catch {
        return apiUrl
      }
    },
    async loadUrl() {
      this.loading = true
      this.error = null
      try {
        const { data } = await axios.get(`${backendAuthUrl}/geobot-url`)
        this.iframeUrl = this.geobotIframeSrc(data.url || null)
        if (!this.iframeUrl) this.error = 'No URL returned'
      } catch (e) {
        const status = e.response?.status
        const msg = e.response?.data?.error || e.message
        // add translation here and in other places
        if (status === 401) this.error = 'Please log in again.'
        else if (status === 403) this.error = 'You do not have access to GeoBot.'
        else if (status === 503) this.error = 'GeoBot is not configured.'
        else this.error = msg || 'Failed to load GeoBot.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.geobot-fab {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 4;
}
.geobot-drawer :deep(.v-navigation-drawer__content) {
  display: flex;
  flex-direction: column;
}
.geobot-toolbar {
  flex-shrink: 0;
}
.geobot-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.geobot-iframe {
  flex: 1;
  width: 100%;
  min-height: 0;
  border: none;
}
</style>
